import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils/src/cn";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/CoPilot/CopilotAgent/TimeLineItem/BasefoldableItem";

const I18n = I18nUtil.createScoped(Translations);

export interface BaseFoldableItemProps {
  children: React.ReactNode;
  topElement?: React.ReactNode;
  leftElement?: React.ReactNode;
  AskQuestionButton?: React.ReactNode;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
  /**
   * 是否显示问答按钮
   * @default true
   */
  isShowAskQuestionButton?: boolean;
  onChartClick?: () => void;
  containerClassName?: string;
  titleContainerClassName?: string;
  "data-tracking-scope"?: string;
}

export const BaseFoldableItem = ({
  children,
  topElement,
  leftElement,
  AskQuestionButton,
  isOpen = false,
  onOpenChange,
  className,
  onChartClick,
  isShowAskQuestionButton = true,
  containerClassName,
  titleContainerClassName,
  ...props
}: BaseFoldableItemProps) => {
  const DefaultAskQuestionButton = () => {
    if (!isShowAskQuestionButton) {
      return null;
    }
    return (
      <div className="flex items-center">
        <button
          aria-label="Base Foldable Item"
          data-openreplay-label="Base Foldable Item Button"
          id="btn-base-foldable-item"
          className={cn(
            "button xs_button button_icon text-content_primary flex items-center gap-1",
            !isShowAskQuestionButton && "hidden",
          )}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onChartClick?.();
          }}
          data-tracking-scope={props["data-tracking-scope"]}
        >
          <Icon
            name="p_chat"
            size={16}
            color={ospThemes.colors.content_primary}
          />
          <span className="button_s">{I18n.t("Ask")}</span>
        </button>
        <span className="border-r border-border_solid h-4 pl-1 mr-1" />
      </div>
    );
  };
  return (
    <div
      data-openreplay-label="TimeLineItem · BasefoldableItem · div"
      className={cn(
        "flex flex-col p-3 md:p-4 rounded-3 bg-background_solid_neutral_primary cursor-pointer",
        className,
      )}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onOpenChange?.(!isOpen);
      }}
      data-tracking-scope="base-foldable-item"
    >
      {topElement && <div className="mb-2">{topElement}</div>}
      <div className={cn("flex flex-col md:gap-3 gap-1", containerClassName)}>
        <div
          className={cn(
            "flex justify-between items-center",
            titleContainerClassName,
          )}
        >
          {leftElement}
          <div className="flex items-center">
            {AskQuestionButton || <DefaultAskQuestionButton />}
            <Icon
              data-openreplay-label="chevron-down"
              name={"chevron-down"}
              size={20}
              color={ospThemes.colors.content_primary}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onOpenChange?.(!isOpen);
              }}
              data-tracking-scope="chevron-down-icon"
              className={cn(
                "transition-transform duration-200 cursor-pointer button_icon px-[2px]",
                isOpen && "rotate-180",
              )}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
